<template>
  <div class="content">
    <header>
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p @click="showpopup">{{timeValue}}</p>
      <van-icon
        name="arrow-down"
        @click="showpopup"
        :class="{pro:show||!show,round:show,round2:!show}"
      />
      <span>总分：</span>
      <span>{{score}}</span>
    </header>
    <van-tabs
      v-model="active"
      animated
      swipeable
      sticky
      :offset-top="44"
      background="#F5F5F5"
      title-active-color="#EC130C"
      title-inactive-color="#666"
      class="tabs"
      ref="tabs"
    >
      <van-tab title="全部评分" class="tabsA tab_All">
        <!-- 缺省页 -->
        <Lack v-if="allScore.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in allScore"
            :key="index"
            @click="goScoreMsg(item.id,item.otherId,item.state)"
            class="scoreList"
          >
            <div>
              <span>{{item.content}}</span>
              <span>{{item.date}}</span>
            </div>
            <span :class='{sty:item.type != 0}'>{{item.type == 0?item.value:'+'+item.value}}</span>
            <van-icon name="arrow" :class="{clicks:item.state != 2 && item.state != 11}" />
          </div>
        </van-list>

      </van-tab>
      <van-tab :title="addScore" class="tabsA tab_join" ref="tab_join">
        <!-- 缺省页 -->
        <Lack v-if="addScoreData.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in addScoreData"
            :key="index"
            class="scoreList"
            @click="goScoreMsg(item.id,item.otherId,item.state)"
          >
            <div>
              <span>{{item.content}}</span>
              <span>{{item.date}}</span>
            </div>
            <span :class='{sty:item.type != 0}'>+{{item.value}}</span>
          </div>
        </van-list>
        
      </van-tab>
      <van-tab :title="cutScore" class="tabsA tab_join" ref="tab_join">
        <!-- 缺省页 -->
        <Lack v-if="cutScoreData.length<=0"></Lack>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="nullText"
          :immediate-check="false"
          @load="onLoad()"
          v-else
        >
          <div
            v-for="(item,index) in cutScoreData"
            :key="index"
            class="scoreList"
            @click="goScoreMsg(item.id,item.otherId,item.state)"
          >
            <div>
              <span>{{item.content}}</span>
              <span>{{item.date}}</span>
            </div>
            <span :class='{sty:item.type != 0}'>{{item.value}}</span>
          </div>
        </van-list>

        
      </van-tab>
    </van-tabs>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { getScoreList } from "@/api/picker/index";
import Lack from "@/components/lack/lack";
export default {
  components: {
    Lack
  },
  data() {
    return {
      show: false,
      currentDate: new Date(), //日期选择器选中的时间
      timeValue: "", //格式化后的时间 2019年05月
      score: "", //总分
      active: "1",
      addScore: "", //加分tab
      cutScore: "", //减分tab
      page: 1, //接口请求页数
      finished: false, //加载完成
      loading: false, //上拉加载
      nullText: "",
      date: "", //接口请求参数-日期
      allScore: [], //所有评分
      checkDate: "", //选择的时间格式化 2019-05
      addScoreData: [], //加分数组
      cutScoreData: [] //减分数组
    };
  },
  mounted() {
    this.timeValue = this.doHandleDate();
    let a = 2;
    this.$store.commit("user/SET_token", this.GetQueryString("token"));
  },
  methods: {
    showpopup: function() {
      if (!this.show) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    // 左上角返回按钮
    returnBack() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.closeHandsel();
        } else {
          // ios环境
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
      }
    },

    // 获取当前的年月
    doHandleDate() {
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      var tMonth = myDate.getMonth();
      var m = tMonth + 1;
      if (m.toString().length == 1) {
        m = "0" + m;
      }
      this.date = tYear + "-" + m;
      this.getScoreList();
      return tYear + "年" + m + "月";
    },

    // 日期格式化
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    timeFormat(time) {
      // 时间格式化 2019年09月
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      // let day = time.getDate();
      this.checkDate = year + "-" + month;
      return year + "年" + month + "月";
    },
    confirm() {
      this.timeValue = this.timeFormat(this.currentDate);
      this.show = false;
      this.page = 1;
      this.getScoreList(this.checkDate);
    },
    cancel() {
      this.show = false;
    },

    //获取评分列表的接口
    getScoreList(date, type) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        date: date || this.date, //月份
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.page.toString(), //请求页
          size: "10" //请求大小
        }
      };
      getScoreList(obj).then(res => {
        // console.log(res);
        let allScoreList = res.content.list;
        let addScoreList = [];
        let cutScoreList = [];
        if (allScoreList.length < 10) {
          // 最后一页不足10条的情况
          this.finished = true;
          setTimeout(() => {
            this.nullText = "没有更多了";
          }, 1000);
        } else {
          if (type) {
            this.finished = false;
          }
        }
        for (let i = 0; i < allScoreList.length; i++) {
          if (allScoreList[i].type == "1") {
            addScoreList.push(allScoreList[i]);
          } else {
            cutScoreList.push(allScoreList[i]);
          }
        }
        if (this.page == 1) {
          this.allScore = allScoreList;
          this.addScoreData = addScoreList;
          this.cutScoreData = cutScoreList;
        } else {
          this.allScore = [...(this.allScore || []), ...allScoreList];
          this.addScoreData = [...(this.addScoreData || []), ...addScoreList];
          this.cutScoreData = [...(this.cutScoreData || []), ...cutScoreList];
        }
        this.addScore = "加分(" + this.addScoreData.length + ")";
        this.cutScore = "减分(" + this.cutScoreData.length + ")";
        this.score = res.content.score;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
      // .finally(() => {
      //   setTimeout(() => {
      //     this.loading = false;
      //   }, 500);
      // });
    },

    onLoad() {
      this.page += 1;
      this.getScoreList();
    },

    goScoreMsg(id, otherId, state) {
      if (state == 12) {
        this.$router.push({
          path: "/complaintRecord",
          query: {}
        }); //跳转
        return;
      }
      if (state == 4) {
        this.$router.push({
          path: "/complaintHandDetails",
          query: {
            id:otherId
          }
        }); //跳转
        return;
      }

      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goScropeDetails(id, otherId, state);
        } else {
          // ios环境
          window.webkit.messageHandlers.goScropeDetails.postMessage({
            id: id,
            otherId: otherId,
            state: state
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  header {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2013;
    width: 100%;
    height: 44px;
    background: #fff;
    i {
      font-size: 20px;
      margin-left: 10px;
    }
    p {
      color: #ec130c;
      font-size: 17px;
      margin-left: 100px;
      font-weight: bold;
    }
    .pro {
      color: #999 !important;
      margin-right: 30px;
      margin-left: 4px !important;
    }
    span {
      font-size: 15px;
      color: #1d1d1d;
      display: block;
      line-height: 44px
    }
    .round {
      animation: myfirst1 0.2s linear 1;
      transform: rotate(180deg);
    }
    .round2 {
      animation: myfirst2 0.2s linear 1;
      transform: rotate(0deg);
    }
    @keyframes myfirst1 {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(180deg);
      }
    }
    @keyframes myfirst2 {
      0% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }
  .tabs {
    margin-top: 44px;
    /deep/.van-tab--active {
      font-weight: bold;
    }
    .tabsA{
      background: #fff;
    }
    .clicks {
      color: #999 !important;
    }
    .scoreList {
      width: auto;
      height: 68px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      border-bottom: 1px solid #f0f0f0;
      div {
        display: flex;
        flex-flow: column;
        width: fit-content;
        margin-right: auto;
        span:first-child {
          color: #1d1d1d;
          font-weight: bold;
          font-size: 16px;
          letter-spacing: 2px;
          margin-bottom: 5.5px;
          text-align: left;
        }
        span:last-child {
          color: #666;
          font-size: 14px;
        }
      }
      > .van-icon {
        font-size: 18px;
        color: #fff;
      }
      > span {
        color: #2dae19;
        font-size: 18px;
        margin-right: 18px;
      }
      >.sty{
        color: #EC130C;
      }
    }
  }
}
</style>

